import React, { PropTypes, Component } from 'react';
import SlidingPanel from 'components/SlidingPanel';
import { mixin, RefluxMixin } from 'Util';
import { AppActions } from 'actions';
import { Styles, FontIcon } from 'material-ui';
import { Colors } from 'components/Material/Styles/Colors';
import ProfileHeaderContainer from 'components/Widgets/ProfileHeaderContainer';
import ProfileLogoutContainer from 'components/Widgets/ProfileLogoutContainer';
import MenuItem from 'components/Material/MenuItem';
import MenuDivider from 'material-ui/lib/menus/menu-divider';
import CollapsibleMenu from 'components/Material/CollapsibleMenu';
import * as Icons from 'components/Icons';
import * as MaterialIcons from 'components/Material/SvgIcons';
import { NotificationStore, AuthStore } from 'stores';
import CoursioLogo from 'components/CoursioLogo';
import ScrollableContainer from 'components/ScrollableContainer';
import { AuthActions } from 'actions';

const { Spacing } = Styles;

const styles = {
  icon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    margin: `0 ${Spacing.desktopGutterMini}px`
  }
};

export default class MainMenu extends mixin(RefluxMixin, SlidingPanel) {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
    locales: PropTypes.array
  };

  listenToStores() {
    this.listenToStoreWithMapper(AuthStore, state => ({
      role: state.role,
      username: state.username,
      roleMap: state.roleMap,
      incarnated: state.incarnated,
      features: state.features
    }));
    this.listenToStoreWithMapper(NotificationStore, state => ({
      unreadNotifications: state.unreadNotifications
    }));
  }

  getMenuItems() {
    const { getIntlMessage } = this.context;
    const { username, unreadNotifications } = this.state;

    const base = [
      {
        route: 'dashboard',
        text: getIntlMessage('menu.Dashboard'),
        icon: Icons.Home
      },
      {
        route: 'communication',
        text: getIntlMessage('menu.Notification'),
        icon: Icons.Communication,
        count: unreadNotifications < 100 ? unreadNotifications : '100+'
      }
    ];

    const mediaLibrary = [
      { divider: true },
      {
        route: 'media-library',
        text: getIntlMessage('menu.mediaLibrary'),
        icon: MaterialIcons.ActionPermMedia
      }
    ];

    const userManagement = [
      {
        header: getIntlMessage('menu.StudentManagement'),
        icon: MaterialIcons.SocialPersonOutline,
        menuItems: [
          {
            route: 'tasks',
            text: getIntlMessage('menu.Tasks'),
            icon: MaterialIcons.ActionAssignmentReturned,
            count: !localStorage.getItem('new:seen') && 'new'
          },
          // { menu: 'app', text: getIntlMessage('menu.Back'), iconClassName: 'md md-keyboard-backspace' },
          {
            route: 'students',
            text: getIntlMessage('student.Students'),
            icon: MaterialIcons.SocialPersonOutline
          },
          {
            route: 'groups',
            text: getIntlMessage('group.Groups'),
            icon: MaterialIcons.SocialPeopleOutline
          },
          {
            route: 'courses',
            text: getIntlMessage('menu.Courses'),
            icon: Icons.Library
          },
          {
            route: 'invite',
            text: getIntlMessage('menu.Invite'),
            icon: MaterialIcons.ContentAdd
          }
          /*{ route: 'sub-accounts', text: getIntlMessage('menu.SubAccounts'), icon: MaterialIcons.CommunicationContacts}*/
        ]
      }
    ];

    if(this.state.features && this.state.features.quiz){
      userManagement[0].menuItems.unshift({
        route: 'quiz',
        text: getIntlMessage('menu.Quiz'),
        icon: MaterialIcons.ActionQuestionAnswer,
        count: !localStorage.getItem('new:seen') && 'new'
      })
    }

    const store = [
      {
        header: getIntlMessage('menu.ECommerce'),
        icon: MaterialIcons.ActionShoppingCart,
        menuItems: [
          {
            route: 'bundles',
            text: getIntlMessage('menu.Bundles'),
            icon: MaterialIcons.EditorBorderAll
          },
          {
            route: 'transactions',
            text: getIntlMessage('menu.Transactions'),
            icon: Icons.Sort
          },
          {
            route: 'discounts',
            text: getIntlMessage('menu.Discounts'),
            icon: MaterialIcons.ActionLabelOutline
          }
        ]
      }
    ];

    const settings = [
      { divider: true },
      {
        route: 'settings',
        text: getIntlMessage('menu.Settings'),
        icon: Icons.Settings
      }
      // { route: 'logout', text: getIntlMessage('menu.Logout'), icon: MaterialIcons.ActionPowerSettingsNew },
    ];

    const notes = [
      { divider: true },
      {
          route: 'notes',
          text: getIntlMessage('menu.Notes'),
          icon: MaterialIcons.ActionSpeakerNotes,
          count: !localStorage.getItem('new:seen') && 'new'
      }
      // { route: 'logout', text: getIntlMessage('menu.Logout'), icon: MaterialIcons.ActionPowerSettingsNew },
    ];

    const stats = [
      { divider: true },
      {
          route: 'statistics',
          text: getIntlMessage('menu.saleStats'),
          icon: Icons.Stats,
          count: !localStorage.getItem('new:seen') && 'new'
      }
      // { route: 'logout', text: getIntlMessage('menu.Logout'), icon: MaterialIcons.ActionPowerSettingsNew },
    ];

    const support = [
      { divider: true },
      {
        action: 'reportBug',
        text: getIntlMessage('bug.report'),
        icon: MaterialIcons.CommunicationLiveHelp
      }
    ];

    const incarnate = [
      {
        route: 'incarnate',
        text: getIntlMessage('menu.Incarnate'),
        icon: MaterialIcons.SocialWhatshot
      }
    ];

    const wakeUp = [
      {
        route: 'wakeup',
        text: getIntlMessage('menu.Wakeup'),
        icon: MaterialIcons.SocialNotificationsActive
      }
    ];

    const { role, roleMap, incarnated } = this.state;
    let menuItems;
    if (role.editor) {
      menuItems = [
        {
          action: 'readerMode',
          text: getIntlMessage('settings.readerMode'),
          icon: MaterialIcons.ActionVisibility
        }
      ];
    } else if (role.reader && roleMap.editor) {
      menuItems = [
        {
          action: 'builderMode',
          text: getIntlMessage('settings.builderMode'),
          icon: MaterialIcons.ContentCreate
        }
      ];
    } else {
      menuItems = [];
    }
    role.owner && store[0].menuItems.unshift({
      route: `store/${username}`,
      text: getIntlMessage('menu.Store'),
      icon: MaterialIcons.ActionShoppingCart
    });
    menuItems = menuItems.concat(role.reader ? base : []);
    menuItems = menuItems.concat(role.reader ? notes : []);
    menuItems = menuItems.concat(mediaLibrary);
    menuItems = menuItems.concat(role.teacher ? userManagement : []);
    menuItems = menuItems.concat(role.teacher || role.accountant ? store : []);
    menuItems = menuItems.concat(role.teacher || role.accountant ? stats : []);
    menuItems = menuItems.concat(settings);
    if (role.assistant) {
      menuItems = menuItems.concat(incarnate);
    }
    if (incarnated) {
      menuItems = menuItems.concat(wakeUp);
    }

    menuItems = menuItems.concat(support);
    return menuItems;
  }

  _onMenuItemClick(payload, event) {

    if(!localStorage.getItem('new:seen') && payload.count === 'new'){
      localStorage.setItem('new:seen', true)
    }
    if (payload.action) {
      this.handleAction(payload.action);
    } else {
      this.props.onChange(event, null, payload);
    }
    this.close();
  }

  handleAction(action) {
    const { locales } = this.context;

    console.log('laca', locales)

    if (action === 'reportBug') {
      if (locales[0] === 'sv-SE') {
        window.location.replace('https://support.coursio.com/hc/sv')
      } else {
        window.location.replace('https://support.coursio.com/hc/en-us')
      }
      return;
    }
    if (this[action]) {
      this[action]();
    }
  }

  builderMode() {
    AuthActions.builderMode();
  }

  readerMode() {
    AuthActions.readerMode();
  }

  reportBug() {
    AppActions.showReportBugDialog();
  }

  renderMenu(menuItems) {
    const children = [];
    menuItems.forEach((menuItem, index) => {
      if (menuItem.menuItems) {
        children.push(
          <MenuDivider style={{ color: Colors.fullWhite }} key={'d' + index} />
        );
        children.push(
          <CollapsibleMenu
            iconColor={Colors.fullWhite}
            menuItemStyle={{ color: Colors.fullWhite }}
            icon={menuItem.icon}
            iconClassName={menuItem.iconClassName}
            initialExpanded={false}
            onItemTap={this._onMenuItemClick.bind(this)}
            key={index}
            menuItems={menuItem.menuItems}
            header={menuItem.header}
          />
        );
      } else if (menuItem.divider) {
        children.push(<MenuDivider key={'d' + index} />);
      } else {
        let leftIcon;
        if (menuItem.icon) {
          leftIcon = (
            <menuItem.icon style={styles.icon} color={Colors.fullWhite} />
          );
        } else {
          leftIcon = (
            <FontIcon
              color={Colors.fullWhite}
              className={menuItem.iconClassName}
            />
          );
        }
        children.push(
          <MenuItem
            count={menuItem.count}
            style={{ color: Colors.fullWhite }}
            onTouchTap={this._onMenuItemClick.bind(this, menuItem)}
            primaryText={menuItem.text}
            key={index}
            index={index}
            leftIcon={leftIcon}
          />
        );
      }
    });
    return children;
  }

  listenToActions() {
    this.listenToAction(AppActions.toggleAppBar, () => {
      this.toggle();
    });
  }

  createPanel(open) {
    const menuItems = this.getMenuItems();
    const menu = this.renderMenu(menuItems);
    return (
      <ScrollableContainer
        header={<ProfileHeaderContainer />}
        style={this.getPanelStyle(open)}
      >
        <div>{menu}</div>
        <div
          style={{
            padding: Spacing.desktopGutterMini,
            textAlign: 'center',
            marginTop: Spacing.desktopGutter
          }}
        >
          <CoursioLogo initialFill={'#ffffff'} size={100} width="48px" />
        </div>
        <div
          style={{
            padding: Spacing.desktopGutterMini,
            textAlign: 'center',
            marginTop: Spacing.desktopGutter,
            paddingLeft: Spacing.desktopGutterMini * 3
          }}
        >
          <ProfileLogoutContainer />
        </div>
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/MainMenu.js